"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductAllOfAplusToJSON = exports.ProductAllOfAplusFromJSONTyped = exports.ProductAllOfAplusFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ProductAllOfAplusFromJSON(json) {
    return ProductAllOfAplusFromJSONTyped(json, false);
}
exports.ProductAllOfAplusFromJSON = ProductAllOfAplusFromJSON;
function ProductAllOfAplusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'iconUrl': json['iconUrl'],
        'isIncluded': json['isIncluded'],
        'price': (0, _1.AmountFromJSON)(json['price']),
        'priceModifications': !(0, runtime_1.exists)(json, 'priceModifications') ? undefined : (json['priceModifications'].map(_1.PriceModificationFromJSON)),
        'finalPrice': (0, _1.AmountFromJSON)(json['finalPrice']),
    };
}
exports.ProductAllOfAplusFromJSONTyped = ProductAllOfAplusFromJSONTyped;
function ProductAllOfAplusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'iconUrl': value.iconUrl,
        'isIncluded': value.isIncluded,
        'price': (0, _1.AmountToJSON)(value.price),
        'priceModifications': value.priceModifications === undefined ? undefined : (value.priceModifications.map(_1.PriceModificationToJSON)),
        'finalPrice': (0, _1.AmountToJSON)(value.finalPrice),
    };
}
exports.ProductAllOfAplusToJSON = ProductAllOfAplusToJSON;
//# sourceMappingURL=ProductAllOfAplus.js.map